import Mousetrap from 'mousetrap';
import React, { useEffect } from 'react';

import { ALT_T } from 'constants/mousetrap';

let localStorage;

// block third party cookies check
// https://useloom.atlassian.net/browse/LOOM-1639
try {
  localStorage = window && window.localStorage;
} catch (err) {
  // do nothing
}

export const THEME_DARK = 'theme-dark';
export const LOCAL_THEME = 'localTheme';

const useTheme = () => {
  const [activeTheme, setActiveTheme] = React.useState(
    localStorage?.getItem(LOCAL_THEME) || ''
  );

  const currentTheme = activeTheme !== THEME_DARK ? THEME_DARK : '';

  useEffect(() => {
    Mousetrap.bind(ALT_T, event => {
      event.preventDefault();

      setActiveTheme(currentTheme);

      localStorage && localStorage.setItem(LOCAL_THEME, currentTheme);
    });

    if (activeTheme === THEME_DARK) {
      document.body.classList.add(THEME_DARK);
    } else {
      document.body.classList.remove(THEME_DARK);
    }

    return () => {
      Mousetrap.unbind(ALT_T);
    };
  }, [activeTheme, currentTheme]);

  return activeTheme;
};

export default useTheme;
